import JustValidate from 'just-validate';
export class CompareCosts {

	constructor() {
	}
	init() {
		const calculators = document.querySelectorAll('.calculator-section.type-compare_college');
		if (!calculators) {
			return;
		}


		calculators.forEach(calculator => {
			const submitButton = calculator.querySelector('button[type=submit]');
			const form = calculator.querySelector('form');
			let activeCol = 0;
			const validator = new JustValidate(form, {
				validateBeforeSubmitting: false,
			});
			validator.onSuccess((e) => {
				//reset totals to zero
				const resultFields = calculator.querySelectorAll('.total .form-item, .grand_total .form-item');
				for (let i = 0; i < resultFields.length; i++) {
					resultFields[i].innerText = "$0";
				}
				const resultGroups = {};
				const formItems = calculator.querySelectorAll('.form-item');
				for (let i = 0; i < formItems.length; i++) {
					const group = formItems[i].getAttribute('data-group');
					const col = formItems[i].getAttribute('data-col');
					if (parseInt(col) === activeCol) {
						formItems[i].classList.add('active');
					} else {
						formItems[i].classList.remove('active');
					}
					if (group) {
						if (!resultGroups[col]) {
							resultGroups[col] = {};
						}
						if (!resultGroups[col][group]) {
							resultGroups[col][group] = 0;
						}
						let number = formItems[i].querySelector('input')?.value;
						if (number) {
							number = parseFloat(number.replace(/[^\d.-]/g, ''));
							resultGroups[col][group] += number;
						}
					}
				}
				for (const col in resultGroups) {
					for (const group in resultGroups[col]) {
						const groupResultField = calculator.querySelector(`.total .form-item[data-group="${group}"][data-col="${col}"]`);
						if (groupResultField) {
							groupResultField.innerText = `${this.mefaCommaNum(resultGroups[col][group].toFixed(2))}`;
						}
					}
				}

				let total = 0;
				for (const col in resultGroups) {
					total = resultGroups[col]["costs"] - resultGroups[col]["gifts"] - resultGroups[col]["loans"] - resultGroups[col]["other"];
					calculator.querySelector(`.grand_total .form-item[data-col="${col}"]`).classList.remove("negative-total");
					if (total < 0) {
						calculator.querySelector(`.grand_total .form-item[data-col="${col}"]`).classList.add("negative-total");
						calculator.querySelector(`.grand_total .form-item[data-col="${col}"]`).innerText = `${this.mefaCommaNum((total * -1).toFixed(2))}`;
					} else {
						calculator.querySelector(`.grand_total .form-item[data-col="${col}"]`).innerText = `${this.mefaCommaNum(total.toFixed(2))}`;
					}
				}
			})
			validator.onFail((e) => {
				console.log("fail");
			});

			validator.revalidate();

			let local = this;
			calculator.querySelectorAll('input, select').forEach(function (el) {
				el.addEventListener('focus', function (e) {
					let col = parseInt(e.target.closest('.form-item').getAttribute('data-col'));
					console.log(col);
					activeCol = col;
					// validator.revalidate();
				});
				el.addEventListener('change', function (e) {
					let val = e.target.value;
					if (!e.target.classList.contains('skip-validation')) {
						if (val !== "") {
							val = local.mefaDecStrip(val);
							if (isNaN(parseFloat(val))) {
								val = 0;
							}
							e.target.value = "$" + (parseFloat(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
						} else {
							e.target.value = "$0";
						}
					}
					validator.revalidate();
				});
			});

			//next / prev mobile
			calculator.querySelectorAll('.carousel-nav').forEach(function (el) {
				el.addEventListener('click', function (e) {
					e.preventDefault();
					let totalCols = calculator.querySelectorAll('.mainheader .form-item').length;
					if (e.target.classList.contains('carousel-nav-next')) {
						activeCol++;
					} else {
						activeCol--;
					}
					if (activeCol >= totalCols) {
						activeCol = 0;
					}
					if (activeCol < 0) {
						activeCol = totalCols - 1;
					}
					validator.revalidate();
				});
			});

			//print function
			calculator.querySelector(".print-action").addEventListener("click", async function (e) {
				e.preventDefault();

				var loadScript = function(src, callback) {
					const script = document.createElement('script');
					script.src = src;
					script.onload = callback;
					document.head.appendChild(script);
				}

				var printDiv = function() {
					if (typeof html2canvas === 'undefined') {
						loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js', function () {
							captureAndPrint();
						});
					} else {
						captureAndPrint();
					}
				}

				var captureAndPrint = function() {
					html2canvas(calculator, {
						useCORS: true,
						width: calculator.scrollWidth,
						height: calculator.scrollHeight,
					}).then(canvas => {
						const imgData = canvas.toDataURL('image/png');
						const printWindow = window.open('', '_blank');
						printWindow.document.write('<html><head><title>Print</title></head><body>');
						printWindow.document.write('<img style="width:auto;height: 100%;margin: 0 auto;" src="' + imgData + '"/>');
						printWindow.document.write('</body></html>');
						printWindow.document.close();
						printWindow.onload = function () {
							printWindow.focus();
							printWindow.print();
							printWindow.close();
						};
					});

				}
				printDiv();
			});

			//setup the tabindex to go vertically instead of horizontally
			const rows = calculator.querySelectorAll('.item');
			if (rows.length === 0) return;

			const numRows = rows.length;
			const numCols = rows[0].querySelectorAll('input').length;

			let tabindex = 1;

			for (let col = 0; col < numCols; col++) {
				for (let row = 0; row < numRows; row++) {
					const prev = rows[row].querySelector(`.carousel-nav-prev[data-col="${col}"]`);
					if (prev) {
						console.log(prev, tabindex);
						prev.tabIndex = tabindex++;
					}
					const input = rows[row].querySelectorAll('input')[col];
					if (input) {
						input.tabIndex = tabindex++;
					}
					const next = rows[row].querySelector(`.carousel-nav-next[data-col="${col}"]`);
					if (next) {
						next.tabIndex = tabindex++;
					}
				}
			}
		});

	}

	mefaCommaNum(nStr) {
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2')
		}
		return '$' + x1 + x2
	}

	mefaDecStrip(nStr) {
		return nStr.replace(/[^0-9\.]+/g, '')
	}

}
